import styled from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, border, getPropTypes } from './utils';

export const RowBuffer = styled.div<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(border)}

  align-self: stretch;
  margin-bottom: -1px;
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

RowBuffer.propTypes = getPropTypes(listProps);

RowBuffer.defaultProps = {
  width: '24px',
};
